import  { useContext } from 'react';
import "../Styles/forgetpassword.css"
import Typography from '@mui/material/Typography';
import NextButton from "../Shared/NextButton";
import "../Styles/style.css"
import { Card } from '@mui/material';
import Input from '../Shared/Input';
import consts from '../Utilities/appConsts.json';
import { useLocation } from 'react-router-dom';
import { LanguageContext } from '../language/LanguageContext';
import useChangePassword from '../hook/useChangePassword';


const NewPassword = () => {
    const { search } = useLocation();
    const { getTranslation } = useContext(LanguageContext);
    const query = new URLSearchParams(search);
    const token = query.get('token');

    const {
        password,
        setPassword,
        secondPassword,
        setSecondPassword,
        isShowHelperText,
        changePassword,
        setIsShowHelperText,
        loading,
        LoaderComponent,
    } = useChangePassword();

    return (
        <Card className="card card-login">
            <LoaderComponent loading={loading}>
            </LoaderComponent>
            <div className='display-fp'>
                <Typography component="h1" className='typography-fp'>{getTranslation(consts.HELP_WHEN_YOU_FORGET_PASSWORD)}</Typography>
                <Typography className='typography-sm-fp-l'>{getTranslation(consts.HERE_YOU_NEED_TO_MODIFY_YOUR_PASSWORD)}</Typography>
                <Input
                    label={getTranslation(consts.YOUR_PASSWORD)}
                    className="textField mt-imput-register"
                    characterLimit={20}
                    isRequired={true}
                    type={"password"}
                    variant="standard"
                    //showHelperText={true}
                    endAdornment={true}
                    value={password ? password : ""}
                    setValue={(password: any) => setPassword(password)}
                />
                <Input
                    label={getTranslation(consts.PLEASE_TYPE_CONFIRM_PASSWORD)}
                    className="textField mt-imput-register"
                    type={"password"}
                    characterLimit={20}
                    isRequired={true}
                    setShowHelperText={setIsShowHelperText}
                    showHelperText={isShowHelperText ? true : false}
                    helperText={isShowHelperText && "זו לא אותה סיסמה שהקלדת קודם"}
                    variant="standard"
                    endAdornment={true}
                    //showHelperText={true}
                    value={secondPassword ? secondPassword : ""}
                    name={"secondPassword"}
                    setValue={(name: any, value: any, setShowHelperText:any)  => {
                        setSecondPassword(value);
                        setShowHelperText && setIsShowHelperText(false);
                    }}
                />
                <NextButton
                    handleOnClick={() => changePassword(token)}
                    class="btn-fp-mail btn-fp-mail-mt"
                    text={getTranslation(consts.ENTRY)}
                />
            </div>
        </Card>
    );
}
export default NewPassword;
